import api from 'src/services/api';
import * as utils from './apiUtils';
import type {
  MtxFetchByMovieIdsParams,
  MtxFetchByDeviceIdParams,
} from 'src/models/apis/mtx/mtxRequest';
import {
  type MtxFetchByMovieIdsResponse,
  type MtxFetchByDeviceIdResponse,
  toSensorData,
  toMtx,
  toMtxMovie,
} from 'src/models/apis/mtx/mtxResponse';
import type { SensorData, Mtx, MtxMovie } from 'src/models/mtx';

export default {
  async fetchByMovieIds(params: MtxFetchByMovieIdsParams): Promise<SensorData[]> {
    const response = await api.get<MtxFetchByMovieIdsResponse>(utils.getApiUrl('/mtxs'), { params });
    return response.data.map(toSensorData);
  },
  async fetchByDeviceId(params: MtxFetchByDeviceIdParams): Promise<{ mtxs: Mtx[]; movies: MtxMovie[] }> {
    const response = await api.get<MtxFetchByDeviceIdResponse>(utils.getApiUrl('/mtxs/by_device_id'), { params });
    return {
      mtxs: response.data.mtxs.map(toMtx),
      movies: response.data.movies.map(toMtxMovie),
    };
  },
};
